import { PropsWithChildren } from 'react';

import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

import { ErrorReport } from './error-report';

/**
 * The SentryErrorBoundary component configured with the fallback set as
 * the ErrorReport component.
 *
 * @component
 * @param {Object} props
 * @param {ReactNode} props.children - The child components to wrap with error handling
 */
export const ErrorBoundary = ({ children }: PropsWithChildren) => {
  return (
    <SentryErrorBoundary
      fallback={({ error, eventId }) => (
        <ErrorReport error={error as Error} eventId={eventId} />
      )}
    >
      {children}
    </SentryErrorBoundary>
  );
};
